/**
 * @generated SignedSource<<9261d7849f12e8f2a23d309ef792607b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApiKeySectionEnableApiKeyMutation$variables = {
  id: string;
};
export type ApiKeySectionEnableApiKeyMutation$data = {
  readonly enableApiKey: {
    readonly enabledApiKeyId: string;
  } | null;
};
export type ApiKeySectionEnableApiKeyMutation = {
  response: ApiKeySectionEnableApiKeyMutation$data;
  variables: ApiKeySectionEnableApiKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "EnableApiKey",
    "kind": "LinkedField",
    "name": "enableApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabledApiKeyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApiKeySectionEnableApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApiKeySectionEnableApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da80c1c69d00696148e9e1e911f64c97",
    "id": null,
    "metadata": {},
    "name": "ApiKeySectionEnableApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation ApiKeySectionEnableApiKeyMutation(\n  $id: ID!\n) {\n  enableApiKey(id: $id) {\n    enabledApiKeyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "71470c81c5983e0649ca5ca122c9a499";

export default node;
